import axiosInstance from "../interceptor/interceptor";
import userApplicationServiceDictionary from "../dictionary/userApplicationDictionary";

export const fetchUserApplications = (
  token: string,
  statusFilter?: string,
  page?: number,
  limit?: number
) => {
  return axiosInstance.post(
    userApplicationServiceDictionary.getApplication(token, statusFilter, page, limit),
    {}
  );
};

export const fetchUserApplicationsFormData = (
  token: string,
  applicationId: string
) => {
  if (applicationId) {
    return axiosInstance.post(
      userApplicationServiceDictionary.getApplicationFormData(
        token,
        applicationId
      ),
      {}
    );
  }
};

// `token` comes from the partner link's decrypted `t` param ("Bearer ...")
// and is sent as the Authorization header instead of the session token.
export const fetchPartnerApplication = (applicationId: string, token?: string) => {
  return axiosInstance.post(
    userApplicationServiceDictionary.partnerApplicationFetch(applicationId),
    {},
    token ? { headers: { Authorization: token } } : undefined
  );
};

export const updateFirstTimeViewOnlyPopupsFlags = (
  token: string,
  applicationNumber: string,
  body: any
) => {
  if (applicationNumber) {
    return axiosInstance.post(
      userApplicationServiceDictionary.updateFirstTimeViewOnlyPopupsFlags(),
      { ...body }
    );
  }
};
